import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginHeader } from "../components/login/LoginHeader";
import { LoginForm } from "../components/login/LoginForm";
import { LoginSuccess } from "../components/login/LoginSuccess";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/authService";

export const Login = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [user, navigate]);

    // 1. Nueva función para el login de Google
    const handleGoogleLogin = async () => {
        try {
            await authService.signInWithOAuth("google");
        } catch (error) {
            console.error("Error al conectar con Google:", error);
            alert("Error al iniciar sesión con Google: " + error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await authService.signInWithOtp(email);
            setEmailSent(true);
        } catch (error) {
            console.error(error);
            alert("Error al enviar el correo: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!emailSent) return;

        const interval = setInterval(async () => {
            const session = await authService.getSession();
            if (session) {
                clearInterval(interval);
                navigate("/");
            }
        }, 2000);

        return () => clearInterval(interval);
    }, [emailSent, navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
            <LoginHeader />

            <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md border border-gray-100">
                {!emailSent ? (
                    <LoginForm 
                        setEmail={setEmail} 
                        handleSubmit={handleSubmit} 
                        handleGoogleLogin={handleGoogleLogin} // <-- Pasamos la función aquí
                        loading={loading} 
                    />
                ) : (
                    <LoginSuccess email={email} />
                )}
            </div>

            <div className="mt-8 text-center text-gray-500 text-sm">
                <p className="flex items-center justify-center space-x-1">
                    <i className="fas fa-shield-alt"></i>
                    <span>Acceso seguro sin contraseñas</span>
                </p>
            </div>
        </div>
    );
};